import springApi from '../../services/springApi'

export const getTickets = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/tickets', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)